import { Error404PageWithTranslations } from '@components/Error/Error404PageWithTranslations';
import { customerRoutes } from 'noddi-util';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Account } from './Home/Account';
import { EditAccount } from './Home/Account/EditAccount';
import { BookingProposals } from './Home/BookingProposals';
import { Bookings } from './Home/Bookings';
import { CarDetailPage } from './Home/Cars';
import { CarsListPage } from './Home/Cars/CarsList';
import { WheelMeasurementPage } from './Home/Cars/WheelMeasurement';
import { Discounts } from './Home/Discounts';
import { FleetPage } from './Home/FleetView';
import { NotificationSettings } from './Home/NotificationSettings';
import { Referrals } from './Home/Referrals';
import { TireOfferHomePage } from './Home/TireOfferHomePage';

export function HomeRouter() {
  return (
    <Routes>
      <Route path={customerRoutes.myCars.getBasePath()} element={<CarsListPage />} />
      <Route path={customerRoutes.myCarDetails.getBasePath()} element={<CarDetailPage />} />
      <Route path={customerRoutes.myCarWheelMeasurements.getBasePath()} element={<WheelMeasurementPage />} />
      <Route path={customerRoutes.discounts.getBasePath()} element={<Discounts />} />
      <Route path={customerRoutes.myReferrals.getBasePath()} element={<Referrals />} />
      <Route path={customerRoutes.editProfile.getBasePath()} element={<EditAccount />} />
      <Route path={customerRoutes.profile.getBasePath()} element={<Account />} />
      <Route path={customerRoutes.fleet.getBasePath()} element={<FleetPage />} />
      <Route
        path={customerRoutes.myMembershipPrograms.getBasePath()}
        element={<Navigate to={customerRoutes.discounts.getPath()} replace />}
      />
      <Route path={customerRoutes.bookings.getBasePath()} element={<Bookings />} />
      <Route path={customerRoutes.bookingProposals.getBasePath()} element={<BookingProposals />} />
      <Route path={customerRoutes.tireOfferHomePage.getBasePath()} element={<TireOfferHomePage />} />
      <Route path={customerRoutes.organizationMembers.getBasePath()} element={<NotificationSettings />} />
      <Route path='/notification-settings' element={<Navigate to='../organization-members' replace />} />
      <Route path='*' element={<Error404PageWithTranslations />} />
    </Routes>
  );
}
